import type { SVGProps } from 'react';
import * as React from 'react';
import { forwardRef, Ref } from 'react';

const SvgProfileFill = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <g clipPath="url(#profile-fill_svg__a)">
      <path
        fill="currentColor"
        d="M21.65 20.625A.75.75 0 0 1 21 21H3a.75.75 0 0 1-.649-1.125c1.428-2.468 3.628-4.238 6.196-5.078a6.75 6.75 0 1 1 6.906 0c2.568.84 4.768 2.61 6.196 5.078a.75.75 0 0 1 0 .75"
      />
    </g>
    <defs>
      <clipPath id="profile-fill_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
const ForwardRef = forwardRef(SvgProfileFill);
export default ForwardRef;
